import('./bootstrap').catch((err: unknown) => {
  // eslint-disable-next-line no-console
  console.error('Error importing `app`:', err);
});
